import React from 'react';
import { IndexRedirect, Route } from 'react-router';

import AppPage from '../../components/AppPage';
import AuthLayout from '../../layouts/AuthLayout';
import UnauthLayout from '../../layouts/UnauthLayout';
import ResetLayout from '../../layouts/ResetLayout';

import PageMeta from '../../components/PageMeta';
import login from './login';
import resetpassword from './resetpassword';
import verifycode from './verifycode';
import verifydob from './verifydob';
import home from './home';
import health from './health';
import family from './family';
import messages from './messages';
import forms from './forms';
import publicForms from './publicForms';
import appointments from './appointments';
import account from './account';
import logout from './logout';
import passwordresetlinkexpiration from "./passwordresetlinkexpiration";

import { loggedIn } from '../../lib/auth.js';


// if you're not logged in we don't want this to be navigable
function redirectToHome(nextState, replace) {
  if (loggedIn()) {
    replace('/home');
  }
}

function redirectToLogin(nextState, replace) {
  if (!loggedIn()) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname }
    })
  }
}

// {redirects} would be included AFTER the first <Route path="/">
// Other named routes are included after the <IndexRoute /> e.g. {messages}{health} etc.
// The last route defined in the routes object is the 404
const routes = (
  <Route path="/">
    <IndexRedirect to="/login" />

    <Route component={UnauthLayout} onEnter={redirectToHome}>
      <Route component={ResetLayout}>
        {login}
        {resetpassword}
        {verifycode}
        {verifydob}
      </Route>
      {publicForms}
      {passwordresetlinkexpiration}
    </Route>

    <Route component={AppPage}>
      <Route component={AuthLayout} onEnter={redirectToLogin}>
        {home}
        {health}
        {family}
        {appointments}
        {messages}
        {forms}
        {account}
        {logout}
      </Route>
    </Route>

    <Route
      path="*"
      getComponents={(location, callback) => { // eslint-disable-line react/jsx-no-bind
        callback(null, () =>
          <div>
            <PageMeta
              meta={[
                {
                  property: 'prerender-status-code',
                  content: 301,
                },
                {
                  property: 'prerender-header',
                  content: `Location:  ${window.location.origin}`,
                },
              ]}
            />
            <h3>404 Not Found Template Can go here</h3>
          </div>
        );
      }}
    />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/index.js